var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"1200"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',[_c('v-card-title',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_vm._v("\n          Logs: "+_vm._s(_vm.function_name)+"\n        ")]),_c('v-flex',{staticStyle:{"text-align":"right"}},[_c('v-btn',{attrs:{"text":"","loading":_vm.l_logs},on:{"click":_vm.loadLog}},[_c('i',{staticClass:"fad fa-sync",staticStyle:{"margin-right":"5px"}}),_vm._v("Refresh")])],1)],1)],1),_c('v-card-text',[(_vm.loaded)?_c('v-data-table',{attrs:{"items":_vm.logs,"headers":[
          {
            text: 'Date / Time',
            value: 'date',
            width: 130
          },
          {
            text: 'HTTP Code',
            value: 'http_status',
            width: 70
          },
          {
            text: 'Content',
            value: 'log_content'
          }
        ]},scopedSlots:_vm._u([{key:"item.log_content",fn:function(ref){
        var item = ref.item;
return [_c('pre',[_vm._v(_vm._s(item.log_content))])]}},{key:"item.http_status",fn:function(ref){
        var item = ref.item;
return [_c('v-chip',{attrs:{"color":_vm.getColorFromStatusCode(item.http_status)}},[_vm._v(_vm._s(item.http_status))])]}}],null,false,3911711387)}):_c('LoadingScreen')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }